/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import type { OperationType } from 'relay-runtime';
import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

type OverviewEntryPointComponent = EntryPointComponent<
	Record<string, OperationType>,
	// oxlint-disable-next-line @typescript-eslint/no-explicit-any
	Record<string, EntryPoint<any, any> | undefined>,
	{},
	{} | null
>;

export const overviewEntryPoint: EntryPoint<OverviewEntryPointComponent, {}> = createEntryPoint({
	root: JSResourceForInteraction<OverviewEntryPointComponent>(
		/* webpackChunkName: "async-itam-ham-overview" */ './OverviewEntryRoot.tsx',
	),
	getPreloadProps: () => ({
		extraProps: {},
	}),
});
